export const GET_FILE_DETAILS = 'GET_FILE_DETAILS';
export const SEARCH_FILE_DETAILS = 'SEARCH_FILE_DETAILS';
export const UPLOAD_FILE = 'UPLOAD_FILE';
export const DELETE_FILE = 'DELETE_FILE';
export const FETCH_FILE_DATA = 'FETCH_FILE_DATA';

export default {
  GET_FILE_DETAILS,
  SEARCH_FILE_DETAILS,
  UPLOAD_FILE,
  DELETE_FILE,
  FETCH_FILE_DATA,
};
